import Service from "../service";
// import AuthService from "../AuthServ

const Injury = {
    getInjurytype() {
        return Service.get('/injurytype')
    },
    getInjuryarea() {
        return Service.get('/injuryarea')
    }
};


export default Injury;
